module.exports = __webpack_public_path__ + "static/media/nj_placeholder.cb830d97.png";